import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FaDatabase, FaBrain, FaLaptopCode, FaChartBar } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import Blog from "./Blog";
import Blog1Img1 from '../../assets/blog/blog1.jpg';
import Blog1Img2 from '../../assets/blog/blog2.jpg';
import Blog1Img3 from '../../assets/blog/blog3.jpg';
import Blog1Img4 from '../../assets/blog/blog4.jpg';

const blogsData = [
  {
    id: 1,
    title: "Unlocking the Power of Data Science & AI",
    date: "October 10, 2023",
    description:
      "Explore how machine learning and AI are transforming industries by unlocking valuable insights and driving innovation in today's digital landscape.",
    logo: <FaBrain size={40} />,
    likes: 12,
    image: Blog1Img1, 
    readMoreLink: "/blog/1",
  },
  {
    id: 2,
    title: "Building Robust Data Engineering Pipelines",
    date: "October 12, 2023",
    description:
      "Discover the art of designing scalable data architectures that ensure efficient ETL processes, real-time analytics, and reliable data flows.",
    logo: <FaDatabase size={40} />,
    likes: 8,
    image: Blog1Img2, 
    readMoreLink: "/blog/2",
  },
  {
    id: 3,
    title: "Mastering Code: From Basics to Advanced",
    date: "October 15, 2023",
    description:
      "Dive into the world of coding with expert insights on best practices, modern frameworks, and techniques to deliver high-quality, scalable software solutions.",
    logo: <FaLaptopCode size={40} />,
    likes: 20,
    image: Blog1Img3,  
    readMoreLink: "/blog/3",
  },
  {
    id: 4,
    title: "Transforming Business Intelligence",
    date: "October 18, 2023",
    description:
      "Learn how interactive dashboards, self-service BI tools, and data visualization techniques can empower businesses to make data-driven decisions.",
    logo: <FaChartBar size={40} />,
    likes: 30,
    image: Blog1Img4,  
    readMoreLink: "/blog/4",
  },
];

const useStyles = makeStyles(() => ({
  container: {
    padding: "40px",
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
    textAlign: "center",
  },
  description: {
    fontSize: "1.2rem",
    color: "#555",
    maxWidth: "800px",
    margin: "0 auto 30px",
    lineHeight: "1.5",
    textAlign: "center",
  },
}));

const Blogs = () => {
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.search]);

  return (
    <div className={classes.container}>
      <h1 className={classes.title}>Dive into Digital Trends</h1>
      <p className={classes.description}>
        Stay updated with our latest articles, expert opinions, and in-depth
        analyses on digital innovation. Whether you're a tech enthusiast or a
        seasoned professional, our blog offers insights to keep you informed and
        inspired.
      </p>
      <Grid container spacing={2}>
        {blogsData.map((blog, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Blog blog={blog} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Blogs;